import React from 'react'
import '../styles/QRsAdminView.css'
import '../styles/MiniList.css'

class MiniList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filterOpen: true,
      filters: {
        serial: '',
        customer: '',
        comments: '',
      },
      editingSerial: null,
      editCustomer: '',
      editLocation: '',
      editComments: '',
      editColor: 'BLUE',
      editError: null,
      saving: false,
    };
    this.toggleFilter = this.toggleFilter.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  startEdit(mini) {
    this.setState({
      editingSerial: mini.Serial,
      editCustomer: mini.Customer ? mini.Customer._id : '',
      editLocation: mini.Location || '',
      editComments: mini.Comments || '',
      editColor: mini.Color || 'BLUE',
      editError: null,
      saving: false,
    })
  }

  cancelEdit() {
    this.setState({ editingSerial: null, editError: null, saving: false })
  }

  parseLocation(value) {
    const match = value.match(/^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/)
    if (!match) return null

    const lat = parseFloat(match[1])
    const lng = parseFloat(match[2])
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null

    return `${lat}, ${lng}`
  }

  saveEdit(mini) {
    const { editCustomer, editLocation, editComments, editColor } = this.state

    let location = editLocation.trim()
    if (location) {
      const parsed = this.parseLocation(location)
      if (!parsed) {
        this.setState({ editError: 'Ubicación inválida. Formato: "lat, lng"' })
        return
      }
      location = parsed
    }

    this.setState({ saving: true, editError: null })

    this.props.onSave(mini.Serial, {
      Customer: editCustomer || null,
      Location: location,
      Comments: editComments.trim(),
      Color: editColor,
    }).then(response => {
      if (response && response.error) {
        this.setState({ saving: false, editError: response.error.message || 'Error al guardar' })
      } else {
        this.setState({ saving: false, editingSerial: null, editError: null })
      }
    })
  }

  render() {
    const { filters, filterOpen, editingSerial, editCustomer, editLocation, editComments, editColor, editError, saving } = this.state;
    const { minis, customers, canEdit } = this.props;

    if (!minis) {
      return (<div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    const sortedCustomers = (customers || [])
      .slice()
      .sort((a, b) => (a.Fullname || '').localeCompare(b.Fullname || ''))

    const filteredMinis = minis.filter(mini => {
      const { serial, customer, comments } = filters;
      if (serial && !mini.Serial.toLowerCase().includes(serial.toLowerCase())) return false;
      if (customer && (!mini.Customer || !mini.Customer.Fullname ||
        !mini.Customer.Fullname.toLowerCase().includes(customer.toLowerCase()))) return false;
      if (comments && (!mini.Comments || !mini.Comments.toLowerCase().includes(comments.toLowerCase()))) return false;
      return true;
    });

    return (
      <div className="mnl-list">
        {/* Collapsible Filter Panel */}
        <div className="qrs-admin-filter-card">
          <div className="qrs-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
          </div>
          {filterOpen && (
            <div className="qrs-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Identificador</label>
                  <input
                    type="text"
                    placeholder="Buscar por serial..."
                    value={filters.serial}
                    onChange={e => this.handleFilterChange('serial', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>Cliente</label>
                  <input
                    type="text"
                    placeholder="Buscar por cliente..."
                    value={filters.customer}
                    onChange={e => this.handleFilterChange('customer', e.target.value)}
                  />
                </div>
                <div className="filter-group">
                  <label>Comentarios</label>
                  <input
                    type="text"
                    placeholder="Buscar por comentarios..."
                    value={filters.comments}
                    onChange={e => this.handleFilterChange('comments', e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Column Headers */}
        <div className="qrs-admin-list-header">
          <div className="qrs-header-col col-id">Identificador</div>
          <div className="qrs-header-col mnl-col">Cliente</div>
          <div className="qrs-header-col mnl-col">Ubicación</div>
          <div className="qrs-header-col mnl-col-color">Color</div>
          <div className="qrs-header-col col-customer">Comentarios</div>
          <div className="qrs-header-col col-payments">Fecha de fabricación</div>
          {canEdit && <div className="qrs-header-col mnl-col-actions">Acciones</div>}
        </div>

        {/* Cards */}
        <div className="qrs-admin-list">
          {filteredMinis.length > 0 ? filteredMinis.map(mini => {
            const editing = editingSerial === mini.Serial

            return (
              <div key={mini.Serial} className="qrs-admin-card">
                <div className="qrs-admin-row">
                  <div className="qrs-admin-status-bar ENABLED"></div>
                  <div className="qrs-admin-content">
                    <div className="qrs-admin-machine-id">
                      <div className="mnl-id-wrap">
                        <img className={`mnl-thumb ${mini.Color === 'GREY' ? 'mnl-grey' : ''}`}
                             src="/images/machines/mini.avif"
                             alt="VACWAYmini" />
                        <div className="qrs-admin-code">{mini.Serial}</div>
                      </div>
                    </div>
                    <div className="mnl-cell">
                      {editing ? (
                        <select className="mnl-select"
                                value={editCustomer}
                                onChange={e => this.setState({ editCustomer: e.target.value })}>
                          <option value="">Sin asignar</option>
                          {sortedCustomers.map(customer => (
                            <option key={customer._id} value={customer._id}>{customer.Fullname}</option>
                          ))}
                        </select>
                      ) : (
                        <div className={`mnl-value ${!mini.Customer ? 'mnl-muted' : ''}`}>
                          {mini.Customer ? mini.Customer.Fullname : 'Sin asignar'}
                        </div>
                      )}
                    </div>
                    <div className="mnl-cell">
                      {editing ? (
                        <div>
                          <input className={`mnl-input ${editError ? 'invalid' : ''}`}
                                 type="text"
                                 placeholder="41.549684, 2.026391"
                                 value={editLocation}
                                 onChange={e => this.setState({ editLocation: e.target.value, editError: null })} />
                          {editError && <div className="mnl-error">{editError}</div>}
                        </div>
                      ) : (
                        <div className={`mnl-value ${!mini.Location ? 'mnl-muted' : ''}`}>
                          {mini.Location ? (
                            <a className="mnl-map-link"
                               href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mini.Location)}`}
                               target="_blank"
                               rel="noopener noreferrer">
                              <i className="fas fa-map-marker-alt"></i> {mini.Location}
                            </a>
                          ) : '—'}
                        </div>
                      )}
                    </div>
                    <div className="mnl-cell-color">
                      {editing ? (
                        <div className="mnl-color-picker">
                          <button className={`mnl-swatch mnl-swatch-blue ${editColor === 'BLUE' ? 'mnl-selected' : ''}`}
                                  title="Azul"
                                  onClick={() => this.setState({ editColor: 'BLUE' })}>
                            {editColor === 'BLUE' && <i className="fas fa-check"></i>}
                          </button>
                          <button className={`mnl-swatch mnl-swatch-grey ${editColor === 'GREY' ? 'mnl-selected' : ''}`}
                                  title="Gris"
                                  onClick={() => this.setState({ editColor: 'GREY' })}>
                            {editColor === 'GREY' && <i className="fas fa-check"></i>}
                          </button>
                        </div>
                      ) : (
                        <div className="mnl-value">
                          <span className={`mnl-color-dot ${mini.Color === 'GREY' ? 'mnl-dot-grey' : 'mnl-dot-blue'}`}></span>
                          {mini.Color === 'GREY' ? 'Gris' : 'Azul'}
                        </div>
                      )}
                    </div>
                    <div className="qrs-admin-machine-customer">
                      {editing ? (
                        <input className="mnl-input"
                               type="text"
                               placeholder="Comentarios..."
                               value={editComments}
                               onChange={e => this.setState({ editComments: e.target.value })} />
                      ) : (
                        <div className="qrs-admin-customer-name">{mini.Comments || '—'}</div>
                      )}
                    </div>
                    <div className="qrs-admin-machine-payments">
                      <div className="qrs-admin-sub">
                        {(new Date(mini.Build_date)).toLocaleString('es-ES', { timeZone: 'Europe/Madrid', hour12: false })}
                      </div>
                    </div>
                    {canEdit && (
                      <div className="mnl-actions">
                        {editing ? (
                          <React.Fragment>
                            <button className="mnl-btn mnl-save"
                                    title="Confirmar"
                                    disabled={saving}
                                    onClick={() => this.saveEdit(mini)}>
                              <i className={`fas ${saving ? 'fa-spinner fa-spin' : 'fa-check'}`}></i>
                            </button>
                            <button className="mnl-btn mnl-cancel"
                                    title="Cancelar"
                                    disabled={saving}
                                    onClick={this.cancelEdit}>
                              <i className="fas fa-times"></i>
                            </button>
                          </React.Fragment>
                        ) : (
                          <button className="mnl-btn mnl-edit"
                                  title="Editar"
                                  onClick={() => this.startEdit(mini)}>
                            <i className="fas fa-pen"></i>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          }) : (
            <div className="qrs-admin-empty">
              <i className="fas fa-tablet-alt"></i>
              <p>No se encontraron minis</p>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default MiniList
